<template>
<vx-card no-shadow>
  <vs-tabs v-model="activeTab" class="tabs-shadow-none" id="profile-tabs" :key="activeTab">
    <vs-tab style="height=100%" icon-pack="feather" icon="icon-user" :label="$t('RealAccounts')">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <tab-user-account-list class="mt-4" serverType="Real" :userName="this.$store.state.AppActiveUser.email" />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-github" :label="$t('DemoAccounts')">
      <div class="tab-social-links md:ml-4 md:mt-0 mt-4 ml-0">
        <tab-user-account-list class="mt-4" serverType="Demo" :userName="this.$store.state.AppActiveUser.email" />
      </div>
    </vs-tab>    
  </vs-tabs> 
</vx-card>
</template>

<script>
import TabUserAccountList from '@/views/components/customer-tab/Tab_User_Account_List.vue'

export default {
  components: {
    TabUserAccountList
  },
  data () {
    return {
      activeTab : 0
    }
  }
}

</script>
